/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { CCBMainComponent} from './CCB_main.component';
import { ViewportScroller } from '@angular/common';
import { Util } from 'src/refresh/service/Util';
import { CCB } from '../_common/data/input-data';

export class CCBMainValidation extends IValidator {

      private viewportScroller:ViewportScroller;

       constructor(private component: CCBMainComponent, private menuID:number) {
             super();
             this.viewportScroller = this.component.viewportScroller;
             this.CCB.backup(this.component.data.CCB);
       }

       private CCB:CCB = new CCB();
       private success: boolean;

       public validate(): boolean {

            this.success = true;

            if (this.component.data.CCB.primaryCaregiver == -1) {
                 this.focus('primaryCaregiver','radio_primaryCaregiverRadio_0').error_PrimEmpty = "CCB_main.errPrimEmpty";
            }                       
                        
            if ( Util.isEmpty(this.component.data.CCB.SSN1) 
                        && Util.isEmpty(this.component.data.CCB.SSN2)
                        && Util.isEmpty(this.component.data.CCB.SSN3) ) {
                  this.focus('sin','input_sinInput').error_SSN = "CCB_main.errSINEmpty"; 
            }else{
                  let sinStr = this.component.data.CCB.SSN1.toString()
                        +this.component.data.CCB.SSN2.toString()
                        +this.component.data.CCB.SSN3.toString();
                        
                  if (!this.isSINValid(sinStr) || Util.isEmpty(this.component.data.CCB.SSN1) 
                  || Util.isEmpty(this.component.data.CCB.SSN2)
                  || Util.isEmpty(this.component.data.CCB.SSN3) ) {
                        this.focus('sin','input_sinInput').error_SSN = "CCB_main.errSINInvald"; 
                  }
            }
            
            if (!this.component.data.CCB.chk_consent) {
                 this.focus('notice','chkbox_noticeCheckbox').error_Notice = "CCB_main.notive_chk_1";
            }

            return this.success;

       }
       
       private jump(tagId:string) : CCBMainComponent {
               if ( this.success )
                    this.viewportScroller.scrollToAnchor(tagId);
               this.success = false;
               return this.component;
       }

       private focus(tagId:string,ctrlId:string) : CCBMainComponent {
            if ( this.success ) {
                 this.viewportScroller.scrollToAnchor(tagId);
                 let ctrl = document.getElementById(ctrlId);
                 ///console.log(ctrl);
                 if ( ctrl ) ctrl.focus();
            }
                 
            this.success = false;
            return this.component;
      }
       
       private isSINValid(sinStr:string):boolean{
       
            if (sinStr.length != 9 && !this.isNumeric(sinStr)) return false;
            if (this.startsWithZero(sinStr)) return false;

            // LUHN ALGORITHM
            let digit = sinStr.split('').map(Number);
            let checksum = 0;
            for(let i = 0; i < digit.length - 1; i += 2) 
                   checksum += digit[i];
            
            let k = 0; 
            for(let i = 0; i < digit.length; i += 2) 
            {
                   if (i < digit.length - 1) 
                   {
                          k = digit[i+1] * 2;
                        
                          if(k > 9) k = (k-10) + 1;
                        
                          checksum += k;
                   }
            }
                        
            let mod = checksum % 10;
            checksum = digit[digit.length - 1] + mod;
            return (checksum % 10) == 0;
       }
       
       private isNumeric(sinStr) {
            return /^(\d+)$/.test(sinStr);
       }

       private startsWithZero(sinStr){
            return /^0[0-9].*$/.test(sinStr);
       }
       public setPCError(){
            return this.component.error_PrimEmpty = "CCB_main.errPrimEmpty";
       }

       public IdOfChanged():number { 
            let inputCCB:CCB = this.component.data.CCB;
            if ( this.CCB.primaryCaregiver != inputCCB.primaryCaregiver 
              || this.CCB.SSN1 != inputCCB.SSN1 
              || this.CCB.SSN2 != inputCCB.SSN2 
              || this.CCB.SSN3 != inputCCB.SSN3 
              || this.CCB.chk_consent != inputCCB.chk_consent 
               ) return this.menuID;

            return 0;
       }
}

